import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../assets/css/style.css";
import L from "leaflet";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import NavigationMapLibre from "../components/NavigationMapModal";
import TopVistasBottomSheet from "../components/TopVistasBottomSheet";
import BusinessHours from "../components/BusinessHours";
import CardActions from "../components/CardActions";
import { useDetalleComercioStore } from "../stores/detalleComercioStore";
import "leaflet/dist/leaflet.css";
import toast from "react-hot-toast";
import { esIOSWebView } from "../utils/detectarIOS";
import BottomSheetReporte from "../components/BottomSheetReporte";
import { obtenerDetalleComercio, obtenerShareLinkComercio, verificarFavorito, toggleFavorito, registrarOpinion, toggleSeguirComercio, registrarVistaComercio, getTop10Vistas, registrarTap } from "../api";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet-gesture-handling";
import Gallery from '../components/Gallery';

const Comercio = () => {
    const navigate = useNavigate();
    const [showTopVistas, setShowTopVistas] = useState(false);
    const [topVistasData, setTopVistasData] = useState([]);
    const [galeria, setGaleria] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [mostrarTextoCompleto, setMostrarTextoCompleto] = useState(false);
    const [comercio, setComercio] = useState(null);
    const [horarios, setHorarios] = useState([]);
    const [yaOpino, setYaOpino] = useState(false);
    const [mostrarMapaNavegacion, setMostrarMapaNavegacion] = useState(false);
    const [mostrarTodasAmenidades, setMostrarTodasAmenidades] = useState(false);
    const { user } = useAuth();
    const [esFavorito, setEsFavorito] = useState(false);
    const [mostrarTodasOpiniones, setMostrarTodasOpiniones] = useState(false);
    const [servicios, setServicios] = useState([]);
    const [amenidades, setAmenidades] = useState([]);
    const [bannerCargado, setBannerCargado] = useState(false);
    const [otrasSucursales, setOtrasSucursales] = useState([]);
    const [opiniones, setOpiniones] = useState([]);
    const [mostrarOpinion, setMostrarOpinion] = useState(false);
    const [genero_usuario_actual, setGeneroUsuario] = useState(false);
    const [mostrarReporte, setMostrarReporte] = useState(false);
    const [mostrarExito, setMostrarExito] = useState(false);
    const [comentario, setComentario] = useState("");
    const [puntuacion, setPuntuacion] = useState(0);
    const [recomienda, setRecomienda] = useState(true);
    const mapRef = useRef(null);
    const carouselRef = useRef(null);
    const [hideHeader, setHideHeader] = useState(false);
    const { id_comercio, id_sucursal } = useParams();
    const [sigue, setSigue] = useState(false);
    const [seguidores, setSeguidores] = useState(0);      

    useEffect(() => {
        document.body.style.overflowY = 'auto';
        document.body.style.height = 'auto';
        document.documentElement.style.overflowY = 'auto';
        document.documentElement.style.height = 'auto';

        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 50) {
                setHideHeader(true);
            } else {
                setHideHeader(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            document.body.style.overflowY = 'hidden';
            document.body.style.height = '100vh';
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const construirURLRed = (plataforma, usuario) => {
        if (!usuario) return null;
        switch (plataforma) {
          case "facebook":
            return usuario.startsWith("http") ? usuario : `https://facebook.com/${usuario}`;
          case "instagram":
            return usuario.startsWith("http") ? usuario : `https://instagram.com/${usuario}`;
          case "twitter":
            return usuario.startsWith("http") ? usuario : `https://twitter.com/${usuario}`;
          case "tiktok":
            return usuario.startsWith("http") ? usuario : `https://tiktok.com/@${usuario}`;
          case "pinterest":
            return usuario.startsWith("http") ? usuario : `https://pinterest.com/${usuario}`;
          case "whatsapp":
            const numero = usuario.replace(/\D/g, "");
            return numero.length >= 8 ? `https://wa.me/${numero}` : null;
          default:
            return null;
        }
    };

    const enviarOpinion = async () => {
        if (puntuacion === 0) {
            toast.dismiss();
            toast.error("Debes seleccionar al menos una estrella.");
          return;
        }
      
        if (comentario.trim().length < 5) {
            toast.dismiss();
          toast.error("Tu opinión debe tener al menos 5 caracteres.");
          return;
        }
      
        const res = await registrarOpinion({
          id_comercio: comercio.id_comercio,
          id_perfil: user.id,
          comentario,
          puntuacion,
          recomienda
        });
      
        if (res.success) {
          setMostrarOpinion(false);
          setMostrarExito(true);
          setYaOpino(true);
        } else {
            toast.dismiss();
          toast.error("No se pudo enviar la opinión");
        }
    };

    const cerrarOpinion = () => {
        const modal = document.querySelector(".opinion-modal-step");
        if (modal) {
          modal.classList.add("closing");
        }
        setTimeout(() => {
          setMostrarOpinion(false);
        }, 300);
      };
      
      const cerrarExito = () => {
        const modal = document.querySelector(".opinion-success-modal");
        if (modal) {
          modal.classList.add("closing");
        }
        setTimeout(async () => {
            setMostrarExito(false);
            try {
              const data = await obtenerDetalleComercio(id_sucursal, user?.id || null);
              if (data.success) {
                setComercio(data.comercio);
                setGaleria(data.galeria || []);
                setHorarios(data.horarios);
                setOtrasSucursales(data.sucursales);
                setGeneroUsuario(data.genero_usuario_actual);
                setServicios(data.servicios);
                setAmenidades(data.amenidades);
                setOpiniones(data.opiniones);
                setYaOpino(data.comercio.ya_opino);
              }
            } catch (error) {
              console.error("Error actualizando comercio tras opinión:", error);
            }
        }, 300);
    };

    const abrirTopVistas = async () => {
        const dataV = await getTop10Vistas();
        setTopVistasData(dataV);
        setShowTopVistas(true);
    };

    const handleToggleSeguir = async () => {
        if (!user || !user.id) {
          toast.dismiss();
          toast.error("Debes iniciar sesión para seguir comercios.");
          return;
        }
      
        const result = await toggleSeguirComercio(user.id, comercio.id_comercio);
      
        if (result.success) {
          setSigue(result.followed);
          setSeguidores((prev) => prev + (result.followed ? 1 : -1));
      
          toast.dismiss();
          toast.success(result.message);
        } else {
          toast.dismiss();
          toast.error(result.message || "No se pudo seguir el comercio.");
        }
      };      

    const handleCompartirComercio = async () => {
        let shareUrl =
          comercio?.share_url ||
          (comercio?.share_token ? `https://go.ubikalo.app/${comercio.share_token}` : null) ||
          comercio?.share_link ||
          comercio?.share;

        if (!shareUrl) {
            try {
                const actualizado = await obtenerShareLinkComercio(id_sucursal);
                if (actualizado?.success && actualizado.share_url) {
                    shareUrl = actualizado.share_url;
                    if (comercio) {
                        setComercio((prev) => prev ? {
                            ...prev,
                            share_url: actualizado.share_url,
                            share_token: actualizado.share_token || prev.share_token || null,
                            share_active: actualizado.share_active ?? prev.share_active,
                        } : prev);
                    }
                }
            } catch (error) {
                console.error("Error recargando enlace de compartir:", error);
            }
        }

        if (!shareUrl) {
            shareUrl = window.location.href;
        }

        const mensaje = `¡Descubrí ${comercio.nombre_comercio} en Ubikalo!`;
        const textoParaCopiar = `${mensaje}\n${shareUrl}`;

        try {
            if (navigator.share) {
                const shareData = {
                    title: comercio.nombre_comercio,
                    text: mensaje,
                    url: shareUrl,
                };

                if (!navigator.canShare || navigator.canShare(shareData)) {
                    await navigator.share(shareData);
                    return;
                }
            }

            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(textoParaCopiar);
                toast.dismiss();
                toast.success("Enlace copiado para compartir");
                return;
            }

            const textarea = document.createElement("textarea");
            textarea.value = textoParaCopiar;
            textarea.setAttribute("readonly", "true");
            textarea.style.position = "absolute";
            textarea.style.left = "-9999px";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            toast.dismiss();
            toast.success("Enlace copiado para compartir");
        } catch (error) {
            if (error?.name === "AbortError" || error?.name === "NotAllowedError") {
                return;
            }
            console.error("Error al compartir comercio:", error);
            toast.dismiss();
            toast.error("No se pudo compartir en este momento.");
        }
    };

      useEffect(() => {
        if (user === undefined) return;

        let cancelled = false;
      
        const store = useDetalleComercioStore.getState();
        const detalleCache = store.obtenerDetalle(id_comercio);

        setCargando(true);
        setComercio(null);
        setHorarios([]);
        setGaleria([]);
        setOtrasSucursales([]);
        setGeneroUsuario(false);
        setServicios([]);
        setAmenidades([]);
        setOpiniones([]);
        setYaOpino(false);
        setSigue(false);
        setSeguidores(0);
        setEsFavorito(false);
        setBannerCargado(false);
        setMostrarTextoCompleto(false);
        setMostrarOpinion(false);
        setMostrarReporte(false);
        setMostrarExito(false);
        setMostrarMapaNavegacion(false);
        setMostrarTodasAmenidades(false);
        setMostrarTodasOpiniones(false);

        if (detalleCache) {
            if (cancelled) return;
            setCargando(false);
            setComercio(detalleCache.comercio);
            setHorarios(detalleCache.horarios);
            setGaleria(detalleCache.galeria || []);
            setOtrasSucursales(detalleCache.sucursales);
            setGeneroUsuario(detalleCache.genero_usuario_actual);
            setServicios(detalleCache.servicios);
            setAmenidades(detalleCache.amenidades);
            setOpiniones(detalleCache.opiniones);
            setYaOpino(detalleCache.comercio.ya_opino);
            document.body.style.overflow = "auto";  
        }
      
        const fetchComercio = async () => {
          try {
            const data = await obtenerDetalleComercio(id_sucursal, user?.id || null);
            if (data.success) {
              if (cancelled) return;
              store.guardarDetalle(id_comercio, data);
              setComercio(data.comercio);
              setHorarios(data.horarios);
              setGaleria(data.galeria || []);
              setSigue(data.comercio.ya_sigue);
              setSeguidores(data.comercio.seguidores || 0);
              setOtrasSucursales(data.sucursales);
              setGeneroUsuario(data.genero_usuario_actual);
              setServicios(data.servicios);
              setAmenidades(data.amenidades);
              setOpiniones(data.opiniones);
              setYaOpino(data.comercio.ya_opino);
      
              const timer = setTimeout(() => {
                if (cancelled) return;
                setCargando(false);
                document.body.style.overflow = "auto";
              }, 3000);

              return () => clearTimeout(timer);
            } else {
              console.error("❌ Error en la API:", data.error);
            }
          } catch (err) {
            console.error("❌ Error al obtener datos del comercio:", err);
          }
        };
      
        fetchComercio();

        return () => {
          cancelled = true;
        };
      }, [id_sucursal, id_comercio, user]);           

      useEffect(() => {
        const verificar = async () => {
          if (user && comercio?.id_comercio) {
            try {
              const favorito = await verificarFavorito(comercio.id_comercio, user.id);
              setEsFavorito(favorito.favorito === true);
            } catch (err) {
              console.error("Error al verificar favorito:", err);
            }
          }
        };
      
        verificar();
      }, [user, comercio]);      
                

    useEffect(() => {
        if (cargando) return;
    
        const carousel = carouselRef.current;
        if (!carousel) return;
    
        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;
    
        const handleMouseDown = (e) => {
        isDown = true;
        startX = e.pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
        carousel.style.cursor = "grabbing";
        };
    
        const handleMouseLeave = () => {
        isDown = false;
        carousel.style.cursor = "grab";
        };
    
        const handleMouseUp = () => {
        isDown = false;
        carousel.style.cursor = "grab";
        };
    
        const handleMouseMove = (e) => {
        if (!isDown) return;
        const x = e.pageX - carousel.offsetLeft;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeft - walk;
        };
    
        const handleTouchStart = (e) => {
        isDown = true;
        startX = e.touches[0].pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
        };
    
        const handleTouchMove = (e) => {
        if (!isDown) return;
        const x = e.touches[0].pageX - carousel.offsetLeft;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeft - walk;
        };
    
        const handleTouchEnd = () => {
        isDown = false;
        };
    
        // Asignar eventos
        carousel.addEventListener("mousedown", handleMouseDown);
        carousel.addEventListener("mouseleave", handleMouseLeave);
        carousel.addEventListener("mouseup", handleMouseUp);
        carousel.addEventListener("mousemove", handleMouseMove);
        carousel.addEventListener("touchstart", handleTouchStart);
        carousel.addEventListener("touchmove", handleTouchMove);
        carousel.addEventListener("touchend", handleTouchEnd);
    
        // Limpieza
        return () => {
        carousel.removeEventListener("mousedown", handleMouseDown);
        carousel.removeEventListener("mouseleave", handleMouseLeave);
        carousel.removeEventListener("mouseup", handleMouseUp);
        carousel.removeEventListener("mousemove", handleMouseMove);
        carousel.removeEventListener("touchstart", handleTouchStart);
        carousel.removeEventListener("touchmove", handleTouchMove);
        carousel.removeEventListener("touchend", handleTouchEnd);
        };
    }, [carouselRef, cargando]);

    useEffect(() => {
        if (cargando || !comercio?.latitud || !comercio?.longitud || !mapRef.current) return;
      
        const latitud = parseFloat(comercio.latitud);
        const longitud = parseFloat(comercio.longitud);
      
        if (mapRef.current && mapRef.current.innerHTML !== "") {
          mapRef.current.innerHTML = "";
        }
      
        if (!L.Map.prototype._gestureHandlingHookAdded) {
          L.Map.addInitHook("addHandler", "gestureHandling", L.GestureHandling);
          L.Map.prototype._gestureHandlingHookAdded = true;
        }
      
        const map = L.map(mapRef.current, {
          center: [latitud, longitud],
          zoom: 17,
          minZoom: 15,
          maxZoom: 20,
          zoomControl: true,
          gestureHandling: true,
        });
      
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
          {
            attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
          }
        ).addTo(map);
      
        const customIcon = L.divIcon({
            className: 'pulse-wrapper',
            html: `<div class="pulse-icon" style="background-image: url('${comercio.logo}')"></div>`,
            iconSize: [45, 45],
            iconAnchor: [22, 45],
            popupAnchor: [0, -40],
          });
      
        L.marker([latitud, longitud], { icon: customIcon })
          .addTo(map)
          .bindPopup(comercio.nombre_comercio)
          .openPopup();
      
        return () => {
          map.remove();
        };
    }, [cargando, comercio]);

    useEffect(() => {
        if (comercio?.id_comercio) {
            const anon_id = localStorage.getItem("anon_id");
            const lat = localStorage.getItem("userLat");
            const lang = localStorage.getItem("userLng");
            registrarVistaComercio(comercio.id_comercio, user?.id || null, anon_id, lat || null, lang || null);
        }
      }, [comercio, user]);      

    if (cargando || !comercio) {
        return (
        <div id="splash">
            <img src="/assets/images/loading.gif" loading="lazy" style={{ width: 300 }} alt="Cargando..." />
        </div>
        );
    }

    const diaActual = new Date().getDay();
    const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    const nombreDia = diasSemana[diaActual];
    const horarioHoy = horarios.find((h) => h.dia === nombreDia);

  return (
    <>
      {cargando && (
        <div id="splash">
          <img src="/assets/images/loading.gif" loading="lazy" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!cargando && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="promo-container">
        <div className={`promo-header ${hideHeader ? "hidden" : ""}`}>
          <button className="promo-btn" onClick={() => navigate("/")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#a5a5a5" fillRule="evenodd" d="M15.488 4.43a.75.75 0 0 1 .081 1.058L9.988 12l5.581 6.512a.75.75 0 1 1-1.138.976l-6-7a.75.75 0 0 1 0-.976l6-7a.75.75 0 0 1 1.057-.081" clipRule="evenodd" />
            </svg>
          </button>
          <div className="promo-actions-right">
            <button
              className="promo-btn"
              onClick={async () => {
                if (!user || !user.id) {
                  toast.dismiss();
                  toast.error("Debes iniciar sesión para utilizar esta característica");
                  return;
                }
                const res = await toggleFavorito(comercio.id_comercio, user.id);
                if (res.success) {
                  setEsFavorito(res.favorito);
                  toast.dismiss();
                  toast.success(res.favorito ? "Agregado a favoritos" : "Eliminado de favoritos");
                } else {
                  toast.error("Ocurrió un error");
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                  fill={esFavorito ? "#ff0000" : "#a5a5a5"}
                  fillRule="evenodd"
                  d="M12 3.942a6.35 6.35 0 0 1 4.305-1.692c1.726 0 3.374.71 4.58 1.96a6.7 6.7 0 0 1 1.865 4.652a6.7 6.7 0 0 1-1.865 4.652c-.796.825-1.591 1.67-2.39 2.518c-1.624 1.724-3.265 3.467-4.97 5.108l-.003.004a2.213 2.213 0 0 1-3.113-.069l-7.295-7.561c-2.485-2.577-2.485-6.727 0-9.303A6.33 6.33 0 0 1 12 3.942"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <button className="promo-btn detalle-btn-share" onClick={handleCompartirComercio} aria-label="Compartir comercio" style={{background:"white"}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#a5a5a5" d="M18 16.08c-.76 0-1.45.3-1.96.79l-7.12-4.14c.05-.23.08-.47.08-.71s-.03-.48-.08-.71l7.1-4.13A2.99 2.99 0 1 0 15 5a2.99 2.99 0 0 0 .02.35l-7.1 4.13A3 3 0 1 0 8 14.52l7.12 4.14A3 3 0 1 0 18 16.08z"/>
              </svg>
            </button>
          </div>
        </div>
        <div className="promo-banner">
            {!bannerCargado && (
              <div className="skeleton-promo skeleton-promo--hero" aria-hidden="true">
                <div className="skeleton-promo__copy">
                  <span className="skeleton-promo__chip" />
                  <span className="skeleton-promo__title" />
                  <span className="skeleton-promo__subtitle" />
                  <span className="skeleton-promo__button" />
                </div>
                <div className="skeleton-promo__art" />
              </div>
            )}
            <img
                src={comercio.portada}
                loading="lazy"
                alt="Promoción"
                onLoad={() => setBannerCargado(true)}
                onError={() => setBannerCargado(true)}
                style={{ opacity: bannerCargado ? 1 : 0 }}
            />
        </div>
        <div className="promo-info">
          <div className="promo-logo">
            <img src={comercio.logo} loading="lazy" alt={comercio.nombre_comercio} />
          </div>
          <div className="promo-details">
            <h2>
                {comercio.nombre_comercio}
                <img src="/assets/images/verified.svg" loading="lazy" className="verifiedUser" style={{ width: 300 }} alt="Verificado"/>
            </h2>
            <p>
                {comercio.online == 0 ? (
                    <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                        <path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64"/>
                        <path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/>
                        </g>
                    </svg>
                    {comercio.direccion}
                    </>
                ) : (
                    <><span style={{color:"#9FD158"}}>Solo servicios en línea.</span></>
                )}
            </p>
          </div>
        </div>
        <div className="promo-stats">
            <p className="promo-counter"> 
                <svg style={{marginRight:4}} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72"/><path fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" d="M336 304c-65.17 0-127.84 32.37-143.54 95.41c-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304Z"/><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94"/><path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M206 306c-18.05-8.27-37.93-11.45-59-11.45c-52 0-102.1 25.85-114.65 76.2c-1.65 6.66 2.53 13.25 9.37 13.25H154"/></svg>
                <strong>{(seguidores || 0).toLocaleString()} personas lo siguen. 
                    <a style={{ fontSize: 12, cursor: "pointer", marginLeft:5 }} onClick={handleToggleSeguir}>
                        {sigue ? "(Dejar de seguir)" : "(Seguir también)"}
                    </a>
                </strong>
            </p>
            <div className="stats-info">
                <p><strong>{opiniones.length} opiniones</strong></p>
                <span>•</span>
                <p>
                    <svg style={{verticalalign:"bottom"}} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#fcc16d" d="m12 16.102l-3.63 2.192q-.16.079-.297.064q-.136-.016-.265-.094q-.13-.08-.196-.226t-.012-.319l.966-4.11l-3.195-2.77q-.135-.11-.178-.263t.019-.293t.165-.23q.104-.087.28-.118l4.216-.368l1.644-3.892q.068-.165.196-.238T12 5.364t.288.073t.195.238l1.644 3.892l4.215.368q.177.03.281.119q.104.088.166.229q.061.14.018.293t-.178.263l-3.195 2.77l.966 4.11q.056.171-.011.318t-.197.226q-.128.08-.265.095q-.136.015-.296-.064z" />
                    </svg>
                    <strong>{comercio.rank || "0.0"}</strong>
                </p>
                <span>•</span>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        if (opiniones.length > 0) {
                        const id_perfil = localStorage.getItem("id_perfil");
                        registrarTap(id_sucursal, "opiniones", id_perfil);
                        setMostrarTodasOpiniones(true);
                        } else {
                        toast("No hay opiniones disponibles", { icon: "😔" });
                        }
                    }}
                    >
                    Ver todas
                </a>
            </div>
        </div>
        {comercio.en_top_10 && (
        <div className="top10-badge" onClick={() => {
            registrarTap(id_sucursal, "elite", user?.id || null);
            abrirTopVistas();
          }}
        >
            <img src="/assets/images/top-10.svg" loading="lazy" alt="Icono Top" />
            <span><b>{comercio.nombre_comercio}</b> forma parte del club élite de esta semana. <small style={{textDecoration: "underline"}}>(Presiona para detalles)</small></span>
        </div>
        )}
        <BusinessHours horarios={horarios} tipoHorario={comercio.tipo_horario} />
        <CardActions
            url={comercio.website}
            telefono={comercio.telefono}
            correo={comercio.correo}
            id_sucursal={comercio.id_sucursal}
            userId={user?.id}
        />
        {otrasSucursales.length > 0 && (
            <div className="otras-sucursales-container">
                <h3 className="otras-sucursales-titulo">Otras sucursales:</h3>

                <div className="otras-sucursales-scroll">
                {otrasSucursales.map((sucursal) => (
                    <div
                        className="otras-sucursales-item"
                        key={sucursal.id_sucursal}
                        onClick={() => {
                            setTimeout(() => {
                                window.location.href = `/comercio/app/${sucursal.id_sucursal}`;
                            }, 100);
                        }}
                    >
                    <img src={sucursal.logo || comercio.logo} alt={sucursal.nombre} loading="lazy" className="otras-sucursales-avatar" />
                    <span className="otras-sucursales-nombre">{sucursal.nombre}</span>
                    </div>
                ))}
                </div>
            </div>
            )}
            <hr></hr>
            <h3 className="services-title" style={{marginBottom:0}}>Amenidades</h3>
            <div className="amenities-section">
                {amenidades.slice(0, 5).map((a, i) => (
                <div className="amenity-item" key={i}>
                    <img
                        loading="lazy"
                        src={a.icono && a.icono !== '' ? a.icono : '/assets/images/default.png'}
                        alt={a.nombre}
                    />
                    <div>
                    <p className="amenity-title">{a.nombre}</p>
                    <p className="amenity-description">{a.descripcion}</p>
                    </div>
                </div>
                ))}
                {amenidades.length > 5 && (
                    <button
                        className="see-all-amenities"
                        onClick={() => {
                            registrarTap(id_sucursal, "amenidades", user?.id || null);
                            setMostrarTodasAmenidades(true);
                        }}
                    >
                    Ver {amenidades.length - 5} amenidades
                    </button>
                )}
            </div>
            <div className="commerce-description">
            <div id="description-text">
                <div
                    dangerouslySetInnerHTML={{
                    __html: mostrarTextoCompleto || (comercio.descripcion?.length || 0) <= 200
                        ? comercio.descripcion
                        : comercio.descripcion?.slice(0, 200) + "...",
                    }}
                />
                {(comercio.descripcion?.length || 0) > 200 && (
                    <span
                    className="read-more"
                    onClick={() => setMostrarTextoCompleto(!mostrarTextoCompleto)}
                    style={{ color: "#007bff", cursor: "pointer", marginLeft: "5px" }}
                    >
                    {mostrarTextoCompleto ? "Leer menos" : "Leer más"}
                    </span>
                )}
                </div>

            </div>
            <hr></hr>
            <h3 className="services-title">Lo que {comercio.nombre_comercio} te ofrece</h3>
            <div className="services-list">
                {servicios.map((serv, idx) => (
                <div className="service-item" key={idx}>
                    <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m9 6l6 6l-6 6" />
                    </svg>
                    {serv.nombre}
                    </span>
                </div>
                ))}
            </div>
            {galeria.length > 0 && (
            <>
                <h3 className="services-title">Galería</h3>
                <Gallery key={id_sucursal} images={galeria.map(f => f.url)} id_sucursal={id_sucursal} userId={user?.id || null} />
            </>
            )}
            <div className="social-container">
                <h3 className="social-title">Redes sociales</h3>
                <div className="social-icons">
                    {construirURLRed("facebook", comercio.facebook) && (
                        <span 
                            onClick={() => {
                                const id_perfil = localStorage.getItem("id_perfil");
                                registrarTap(comercio.id_sucursal, "facebook", id_perfil);
                                setTimeout(() => {
                                    if (window.flutter_inappwebview) {
                                        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", construirURLRed("facebook", comercio.facebook));
                                    } else {
                                        window.open(construirURLRed("facebook", comercio.facebook), "_blank");
                                    }                                
                                }, 200);
                            }}
                            className="facebook" target="_blank" rel="noopener noreferrer">
                            <img src="/assets/images/fb.png" loading="lazy" alt="Facebook" />
                        </span>
                    )}
                    {construirURLRed("instagram", comercio.instagram) && (
                        <span
                            onClick={() => {
                                const id_perfil = localStorage.getItem("id_perfil");
                                registrarTap(comercio.id_sucursal, "instagram", id_perfil);
                                setTimeout(() => {
                                    if (window.flutter_inappwebview) {
                                        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", construirURLRed("instagram", comercio.instagram));
                                    } else {
                                        window.open(construirURLRed("instagram", comercio.instagram), "_blank");
                                    }
                                }, 200);
                            }} 
                            className="instagram" target="_blank" rel="noopener noreferrer">
                            <img loading="lazy" src="/assets/images/ig.png" alt="Instagram" />
                        </span>
                    )}
                    {construirURLRed("twitter", comercio.twitter) && (
                        <span 
                            onClick={() => {
                                const id_perfil = localStorage.getItem("id_perfil");
                                registrarTap(comercio.id_sucursal, "twitter", id_perfil);
                                setTimeout(() => {
                                    if (window.flutter_inappwebview) {
                                        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", construirURLRed("twitter", comercio.twitter));
                                    } else {
                                        window.open(construirURLRed("twitter", comercio.twitter), "_blank");
                                    }
                                }, 200);
                            }}
                            className="twitter" target="_blank" rel="noopener noreferrer">
                            <img loading="lazy" src="/assets/images/x.png" alt="Twitter" />
                        </span>
                    )}
                    {construirURLRed("tiktok", comercio.tiktok) && (
                        <span 
                            onClick={() => {
                                const id_perfil = localStorage.getItem("id_perfil");
                                registrarTap(comercio.id_sucursal, "tiktok", id_perfil);
                                setTimeout(() => {
                                    if (window.flutter_inappwebview) {
                                        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", construirURLRed("tiktok", comercio.tiktok));
                                    } else {
                                        window.open(construirURLRed("tiktok", comercio.tiktok), "_blank");
                                    }
                                }, 200);
                            }}
                            className="tiktok" target="_blank" rel="noopener noreferrer">
                            <img loading="lazy" src="/assets/images/tiktok.png" alt="TikTok" />
                        </span>
                    )}
                    {construirURLRed("pinterest", comercio.pinterest) && (
                        <span 
                            onClick={() => {
                                const id_perfil = localStorage.getItem("id_perfil");
                                registrarTap(comercio.id_sucursal, "pinterest", id_perfil);
                                setTimeout(() => {
                                    if (window.flutter_inappwebview) {
                                        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", construirURLRed("pinterest", comercio.pinterest));
                                    } else {
                                        window.open(construirURLRed("pinterest", comercio.pinterest), "_blank");
                                    }
                                }, 200);
                            }} 
                            className="pinterest" target="_blank" rel="noopener noreferrer">
                            <img loading="lazy" src="/assets/images/pinterest.png" alt="Pinterest"/>
                        </span>
                    )}
                    {construirURLRed("whatsapp", comercio.whatsapp) && (
                        <span 
                            onClick={() => {
                                const id_perfil = localStorage.getItem("id_perfil");
                                registrarTap(comercio.id_sucursal, "whatsapp", id_perfil);
                                setTimeout(() => {
                                    if (window.flutter_inappwebview) {
                                        window.flutter_inappwebview.callHandler("abrirEnlaceExterno", construirURLRed("whatsapp", comercio.whatsapp));
                                    } else {
                                        window.open(construirURLRed("whatsapp", comercio.whatsapp), "_blank");
                                    }
                                }, 200);
                            }} 
                            className="whatsapp" target="_blank" rel="noopener noreferrer">
                            <img loading="lazy" src="/assets/images/whatsapp.png" alt="WhatsApp" />
                        </span>
                    )}
                </div>
            </div>
            
            {comercio.online == 1 && (
                <span style={{marginTop:45, display: "block"}}></span>
            )}

            {comercio.online == 0 && (
                <div className="map-container" style={{ marginRight: 10, marginLeft: 10 }}>
                    <h3 className="map-title">Dónde está ubicado</h3>
                    <div
                    id="map"
                    ref={mapRef}
                    style={{
                        height: "300px",
                        width: "100%",
                        borderRadius: "10px"
                    }}
                    ></div>
                </div>
            )}

            {user && !yaOpino && (
            <div className="opinion-banner">
                <img loading="lazy" src={comercio.logo} alt={comercio.nombre_comercio} className="opinion-logo" />
                <div className="opinion-content">
                <p className="opinion-text">
                    {comercio.online == 1 ? (
                        <>¿Ya consumiste o utilizaste <b>{comercio.nombre_comercio}</b>? ¿Qué te pareció?</>
                    ) : (
                        <>
                        ¿Ya visitaste <b style={{ marginRight: -2 }}>{comercio.nombre_comercio}</b>{" "}
                        <img
                            loading="lazy"
                            src="/assets/images/verified.svg"
                            className="verifiedUser"
                            style={{ width: 300, marginLeft: 0 }}
                            alt="Verificado"
                        />? ¿Qué te pareció?
                        </>
                    )}
                </p>
                <button
                    onClick={() => setMostrarOpinion(true)}
                    className="opinion-button"
                >
                    Comparte tu opinión con los demás
                </button>
                </div>
            </div>
            )}
            {!user && (
            <div className="opinion-banner">
                <img loading="lazy" src={comercio.logo} alt={comercio.nombre_comercio} className="opinion-logo" />
                <div className="opinion-content">
                <p className="opinion-text">
                    ¿Ya visitaste <b style={{marginRight:-2}}>{comercio.nombre_comercio}</b> <img src="/assets/images/verified.svg" loading="lazy" className="verifiedUser" style={{ width: 300, marginLeft:0 }} alt="Verificado" />? ¿Qué te pareció?
                </p>
                <button
                    onClick={() => {
                        toast.dismiss();
                        toast.error("Debes iniciar sesión para realizar opiniones");
                      }}
                    className="opinion-button"
                >
                    Comparte tu opinión con los demás
                </button>
                </div>
            </div>
            )}
            <div className="reviews-container">
                <h2 className="reviews-title">¿Qué opinan las personas?</h2>
                <p className="reviews-counter">({opiniones.length} opiniones)</p>
                {opiniones.length === 0 ? (
                    <div className="no-reviews">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 20 20"><path fill="currentColor" d="M13 4a2 2 0 1 0-1.137 1.805a7.7 7.7 0 0 1-.51 1.779c-.408.955-.995 1.757-1.727 2.585a.5.5 0 0 0 .749.662c.767-.868 1.43-1.761 1.897-2.855C12.74 6.88 13 5.611 13 4m5 4.79v3.486c0 1.418-1.164 2.566-2.6 2.566h-4.59l-4.011 2.961a1.01 1.01 0 0 1-1.4-.199a.98.98 0 0 1-.199-.59v-2.172h-.6c-1.436 0-2.6-1.149-2.6-2.566v-6.71C2 4.149 3.164 3 4.6 3h3.57c-.11.313-.17.65-.17 1H4.6C3.704 4 3 4.713 3 5.566v6.71c0 .853.704 1.566 1.6 1.566h1.6V17h.003l.002-.001l4.276-3.157H15.4c.896 0 1.6-.713 1.6-1.566V10.42c.37-.5.71-1.037 1-1.63M16 2a2 2 0 0 1 2 2c0 1.61-.26 2.88-.728 3.976c-.467 1.094-1.13 1.987-1.897 2.855a.5.5 0 0 1-.75-.662c.733-.828 1.32-1.63 1.728-2.585c.225-.528.4-1.11.51-1.78A2 2 0 1 1 16 2"/></svg>
                    <p className="no-reviews-text">Aún no hay opiniones</p>
                    </div>
                ) : (
                    <>
                    <div className="carousel-wrapper">
                        <div className="carousel" ref={carouselRef}>
                        {opiniones.slice(0, 5).map((op, i) => (
                            <div className="review-card" key={i}>
                            <div className="review-header">
                            <img
                                loading="lazy"
                                src={
                                    op.genero_usuario === "masculino"
                                    ? "/assets/images/masculino.png"
                                    : op.genero_usuario === "femenino"
                                    ? "/assets/images/femenino.png"
                                    : "/assets/images/indefinido.png"
                                }
                                alt="Foto de perfil"
                                />
                                {op.nombre_usuario}
                            </div>
                            <div className="review-stars">
                                {[1, 2, 3, 4, 5].map((s) => (
                                    <span key={s} className={s <= op.puntuacion ? "star filled" : "star"}>★</span>
                                ))}
                            </div>
                            <p>{op.comentario}</p>
                            </div>
                        ))}
                        </div>
                    </div>
                    </>
                )}
                {opiniones.length > 5 && (
                    <p className="see-all" onClick={() => {
                        const id_perfil = localStorage.getItem("id_perfil");
                        registrarTap(id_sucursal, "opiniones", id_perfil);
                        setMostrarTodasOpiniones(true);
                      }}>
                        Presiona para ver todas
                    </p>
                )}
                {opiniones.length <= 5 && (
                    <p className="empty-op"></p>
                )}
            </div>
            <div className="report-business">
                <span onClick={() => {
                    if (!user || !user.id) {
                        toast.dismiss();
                        toast.error("Necesitas acceder a tu cuenta para continuar.");
                        return;
                    }
                    setMostrarReporte(true);
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.5 17.5v-11m0 0q1-2 3-2c2 0 2 2 4 2q2 0 3-1v6q-1 1-3 1c-2 0-2-2-4-2q-2 0-3 2z" strokeWidth="1" />
                    </svg>
                    Reportar un problema con este negocio
                </span>
            </div>
            {mostrarReporte && (
                <BottomSheetReporte
                    comercio={id_sucursal}
                    sucursal={id_sucursal}
                    nombreComercio={comercio.nombre_comercio}
                    usuario={user}
                    onClose={() => setMostrarReporte(false)}
                />
                )}
            <div className="floating-buttons-container">
                <div className="floating-buttons">
                    <button className="btn-message"  
                        onClick={() => {
                            registrarTap(id_sucursal, "conexion", user?.id || null);
                            navigate(`/chat/${comercio.id_comercio}/${id_sucursal}`, {
                                state: { from: "comercio" }
                            });
                      }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><path fill="currentColor" d="M6 7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7m.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM2 8a6 6 0 1 1 2.996 5.195l-2.338.78a.5.5 0 0 1-.639-.612l.712-2.491A6 6 0 0 1 2 8m6-5a5 5 0 0 0-4.3 7.552a.5.5 0 0 1 .05.393l-.509 1.78l1.658-.552a.5.5 0 0 1 .426.052A5 5 0 1 0 8 3"></path></svg>
                        Nueva conexión
                    </button>
                    {comercio.online == 0 ? (
                    <button
                        className="btn-map"
                        onClick={async () => {
                            const lat = localStorage.getItem("userLat");
                            const lng = localStorage.getItem("userLng");
                          
                            if (lat && lng) {
                              registrarTap(id_sucursal, "mapa", user?.id || null);
                              setMostrarMapaNavegacion(true);
                              return;
                            }
                          
                            const esIOS = esIOSWebView();
                          
                            if (esIOS) {
                              const tienePermiso = await window.flutter_inappwebview?.callHandler("verificarUbicacion");
                          
                              if (!tienePermiso) {
                                toast.dismiss();
                                toast.error("Se necesita acceso a tu ubicación para abrir el mapa.");
                                return;
                              }
                          
                              const lat = await window.flutter_inappwebview.callHandler("obtenerLat");
                              const lng = await window.flutter_inappwebview.callHandler("obtenerLng");
                          
                              if (lat && lng) {
                                localStorage.setItem("userLat", lat);
                                localStorage.setItem("userLng", lng);
                                registrarTap(id_sucursal, "mapa", user?.id || null);
                                setMostrarMapaNavegacion(true);
                                return;
                              } else {
                                toast.dismiss();
                                toast.error("No se pudo obtener tu ubicación.");
                                return;
                              }
                            }
                          
                            // Android y Web
                            if (navigator.permissions) {
                              try {
                                const status = await navigator.permissions.query({ name: "geolocation" });
                                if (status.state === "granted" || status.state === "prompt") {
                                  navigator.geolocation.getCurrentPosition(
                                    (position) => {
                                      const { latitude, longitude } = position.coords;
                                      localStorage.setItem("userLat", latitude);
                                      localStorage.setItem("userLng", longitude);
                                      registrarTap(id_sucursal, "mapa", user?.id || null);
                                      setMostrarMapaNavegacion(true);
                                    },
                                    (error) => {
                                      toast.dismiss();
                                      toast.error("No se pudo obtener tu ubicación. Intentá de nuevo.");
                                    },
                                    {
                                      enableHighAccuracy: true,
                                      timeout: 7000,
                                    }
                                  );
                                } else {
                                  toast.dismiss();
                                  toast.error("No se otorgaron permisos de ubicación.");
                                }
                              } catch (err) {
                                toast.dismiss();
                                toast.error("Error al verificar permisos de ubicación.");
                              }
                            } else {
                              navigator.geolocation.getCurrentPosition(
                                (position) => {
                                  const { latitude, longitude } = position.coords;
                                  localStorage.setItem("userLat", latitude);
                                  localStorage.setItem("userLng", longitude);
                                  registrarTap(id_sucursal, "mapa", user?.id || null);
                                  setMostrarMapaNavegacion(true);
                                },
                                (error) => {
                                  toast.dismiss();
                                  toast.error("No se pudo obtener tu ubicación.");
                                },
                                {
                                  enableHighAccuracy: true,
                                  timeout: 7000,
                                }
                              );
                            }
                          }}                          
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                                <path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64" />
                                <path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4" />
                            </g>
                        </svg>
                        Abrir mapa
                    </button>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
      </div>
      <AnimatePresence>
      {mostrarTodasAmenidades && (
        <>
            <motion.div
                key="amenidades-modal"
                initial={{ y: "100%", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: "100%", opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                    display: "flex",
                    justifyContent: "center", 
                    alignItems: "flex-end",
                    position: "fixed",
                    top: 0, left: 0, right: 0, bottom: 0,
                    zIndex: 9999
                  }}
    	    >
            <div className="overlay active" onClick={() => setMostrarTodasAmenidades(false)}></div>
            <div className="amenities-modal">
            <div className="amenities-modal-header">
                <span>Todas las amenidades</span>
                <button className="close-btn" onClick={() => setMostrarTodasAmenidades(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                    <path fill="#ff0000" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z" />
                </svg>
                </button>
            </div>
            <div className="amenities-modal-content">
                {amenidades.map((a, i) => (
                <div className="amenity-item" key={i}>
                    <img
                        loading="lazy"
                        src={a.icono && a.icono !== '' ? a.icono : '/assets/images/default.png'}
                        alt={a.nombre}
                    />
                    <div>
                    <p className="amenity-title">{a.nombre}</p>
                    <p className="amenity-description">{a.descripcion}</p>
                    </div>
                </div>
                ))}
            </div>
            </div>
            </motion.div>
            </>
        )}
        </AnimatePresence>
        <AnimatePresence>
            {mostrarTodasOpiniones && (
            <>
            <motion.div
                key="amenidades-modal"
                initial={{ y: "100%", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: "100%", opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                    display: "flex",
                    justifyContent: "center", 
                    alignItems: "flex-end",
                    position: "fixed",
                    top: 0, left: 0, right: 0, bottom: 0,
                    zIndex: 9999
                  }}
    	    >
                <div className="overlay active" onClick={() => setMostrarTodasOpiniones(false)}></div>
                <div className="amenities-modal expanded">
                <div className="amenities-modal-header">
                    <span>Todas las opiniones</span>
                    <button className="close-btn" onClick={() => setMostrarTodasOpiniones(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                        <path fill="#ff0000" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z" />
                    </svg>
                    </button>
                </div>
                <div className="amenities-modal-content">
                    {opiniones.map((op, i) => (
                    <div className="review-card" key={i}>
                        <div className="review-header">
                        <img
                            loading="lazy"
                            src={
                                op.genero_usuario === "masculino"
                                ? "/assets/images/masculino.png"
                                : op.genero_usuario === "femenino"
                                ? "/assets/images/femenino.png"
                                : "/assets/images/indefinido.png"
                            }
                            alt={op.nombre_usuario}
                        />
                        {op.nombre_usuario}
                        </div>
                        <div className="review-stars">
                            {[1, 2, 3, 4, 5].map((s) => (
                                <span key={s} className={s <= op.puntuacion ? "star filled" : "star"}>★</span>
                            ))}
                            </div>
                        <p>{op.comentario}</p>
                    </div>
                    ))}
                </div>
                </div>
                </motion.div>
            </>
            )}
            </AnimatePresence>
            {mostrarOpinion && (
            <>
                <div className="opinion-overlay" onClick={() => setMostrarOpinion(false)}></div>
                <div className="opinion-modal-step">
                <div className="opinion-modal-header">
                    <img src={comercio.logo} alt={comercio.nombre_comercio} loading="lazy" className="opinion-logo" />
                    ¿Cómo fue tu experiencia con {comercio.nombre_comercio}?
                </div>
                <div className="opinion-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                    <span
                        key={star}
                        onClick={() => setPuntuacion(star)}
                        className={star <= puntuacion ? "star filled" : "star"}
                    >
                        ★
                    </span>
                    ))}
                </div>
                <textarea
                    className="opinion-textarea"
                    placeholder="Escribe tu opinión..."
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                />
                <div className="opinion-recommend">
                    <p>¿Se lo recomendarías a un amigo o familiar?</p>
                    <label>
                    <input type="radio" checked={recomienda} onChange={() => setRecomienda(true)} /> Sí
                    </label>
                    <label>
                    <input type="radio" checked={!recomienda} onChange={() => setRecomienda(false)} /> No
                    </label>
                </div>
                <div className="opinion-buttons">
                    <button  onClick={cerrarOpinion}>Cancelar</button>
                    <button onClick={enviarOpinion}>Enviar</button>
                </div>
                </div>
            </>
            )}
            {showTopVistas && (
                <TopVistasBottomSheet
                    onClose={() => setShowTopVistas(false)}
                    datos={topVistasData}
                />
            )}
            {mostrarExito && (
            <>
                <div className="opinion-overlay" onClick={cerrarOpinion}></div>
                <div className="opinion-success-modal">
                    <svg className="check-pop" xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 50 50"><path fill="currentColor" d="M25 42c-9.4 0-17-7.6-17-17S15.6 8 25 8s17 7.6 17 17s-7.6 17-17 17m0-32c-8.3 0-15 6.7-15 15s6.7 15 15 15s15-6.7 15-15s-6.7-15-15-15"/><path fill="currentColor" d="m23 32.4l-8.7-8.7l1.4-1.4l7.3 7.3l11.3-11.3l1.4 1.4z"/></svg>
                    <h3>¡Opinión enviada!</h3>
                    <p>Gracias por compartir tu experiencia.</p>
                    <button onClick={cerrarExito}>Ok</button>
                </div>
            </>
            )}
            {mostrarMapaNavegacion && (
                <NavigationMapLibre
                    comercioLat={parseFloat(comercio.latitud)}
                    comercioLng={parseFloat(comercio.longitud)}
                    comercioLogo={comercio.logo}
                    comercioNombre={comercio.nombre}
                    tipoHorario={comercio.tipo_horario}
                    horarioHoy={horarioHoy}
                    generoUsuario={genero_usuario_actual}
                    onClose={() => setMostrarMapaNavegacion(false)}
                    id_sucursal={comercio.id_sucursal}
                />
            )}
        </div>
    </motion.div>
    )}
    </>
  );
};

export default Comercio;
